<template>
  <div class="container-fluid">
    <div class="row" v-if="$i18n.locale === 'tw'">
      <div class="col-12">
        <b-carousel
          controls
          indicators
          background="#ffffff"
        >
          <b-carousel-slide v-for="slide in slides">
            <b-img
              fluid
              class="w-100 d-block"
              slot="img"
              :src="slide.background_image.url"
              @click="showSlideRelatedData(slide.related)"
            ></b-img>
          </b-carousel-slide>
        </b-carousel>
      </div>
    </div>
    <div class="row mt-3" v-if="$i18n.locale === 'tw'">
      <div class="col-sm-3 col-6 pb-3" v-for="(link, index) in links_tw">
        <b-link :to="link.to">
          <b-img center fluid-grow :src="link.image.url"></b-img>
        </b-link>
      </div>
    </div>
    <div class="row mt-3" v-if="$i18n.locale === 'en'">
      <div class="col-sm-3 col-6 pb-3" v-for="(link, index) in links_en">
        <b-link :to="link.to">
          <b-img center fluid-grow :src="link.image.url"></b-img>
        </b-link>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <tabs fill class="flex-column flex-md-row">
          <card shadow>
            <tab-pane :title="$t('dharma.list.latest.title')" v-if="books">
              <b-card-group deck>
                <b-card
                  img-top
                  :img-src="book.cover.url"
                  :img-alt="book.chinese_name"
                  :title="`${book.chinese_name} ${book.code}`"
                  v-for="book in books"
                >
                  <b-card-text>{{ book.chinese_author }}</b-card-text>
                  <b-button
                    variant="outline-primary"
                    @click="showBookInfo(book)"
                  >{{ $t('dharma.list.latest.button.introduction.label') }}</b-button>
                </b-card>
              </b-card-group>
            </tab-pane>
            <tab-pane :title="$t('course.list.latest.title')" v-if="$i18n.locale === 'tw'">
              <b-card-group deck>
                <b-card
                  img-top
                  :img-alt="course.title_full_name"
                  :img-src="course.lecturer.photo.url"
                  v-for="course in courses"
                  :title="course.title_full_name"
                >
                  <b-card-text>{{ course.lecturer.lecr_full_name }}</b-card-text>
                  <b-button
                    variant="outline-primary"
                    @click="showCourseInfo(course)"
                  >{{ $t('course.list.latest.button.introduction.label') }}</b-button>
                </b-card>
              </b-card-group>
            </tab-pane>
            <tab-pane :title="$t('series.list.latest.title')" v-if="$i18n.locale === 'tw'">
              <b-card-group deck>
                <b-card
                  img-top
                  :img-alt="item.title_name"
                  :img-src="item.photo.url"
                  :title="`${item.title_name} ${item.title_no}`"
                  v-for="item in series"
                >
                  <b-card-text>{{ item.lecr_name }}</b-card-text>
                  <b-button
                    squared
                    variant="outline-primary"
                    target="_blank"
                    :to="{ name: 'series', params: { series_no: item.title_no } }"
                  >{{ $t('series.list.latest.button.introduction.label') }}</b-button>
                </b-card>
              </b-card-group>
            </tab-pane>
          </card>
        </tabs>
      </div>
    </div>
    <dharma-application-form ref="application_form"></dharma-application-form>
    <info-modal id="bulletin-info" :title="$t('bulletin.title')">
      <template #info>
        <bulletin-info :bulletin="bulletin"></bulletin-info>
      </template>
    </info-modal>
    <info-modal id="sidelight-info" :title="$t('sidelight.title')">
      <template #info>
        <sidelight-info :sidelight="sidelight"></sidelight-info>
      </template>
    </info-modal>
    <info-modal id="course-info" :title="$t('course.detail.title')">
      <template #info>
        <course-info :course="course"></course-info>
      </template>
    </info-modal>
    <info-modal id="event-info" :title="$t('event.detail.title')">
      <template #info>
        <event-info :event="event"></event-info>
      </template>
    </info-modal>
    <div>
      <b-modal id="book-info" :title="$t('dharma.detail.title')" scrollable centered>
        <book-info :book="book"></book-info>
        <b-button-toolbar>
          <b-button-group>
            <b-button variant="outline-default" @click="showSizeCmConversionTable()">{{ $t('book.button.size-cm-conversion.label') }}</b-button>
          </b-button-group>
          <b-button-group>
            <b-button
              variant="primary"
              @click="addBookToApplicationList(book)"
              :disabled="book && book.in_stock === 'N'"
            >{{ book && book.in_stock === 'N' ? $t('book.button.application.label.out-of-stock') : $t('book.button.application.label.in-stock') }}</b-button>
            <b-button variant="info" @click="showDownloadList(book)">{{ $t('book.button.download.label') }}</b-button>
          </b-button-group>
        </b-button-toolbar>
        <template #modal-footer="{ close }">
          <b-button class="w-100" variant="default" @click="close()">{{ $t('modal.button.close.label') }}</b-button>
        </template>
      </b-modal>
      <b-modal id="size-cm-conversion-table" :title="$t('size-cm-conversion-table.title')" centered>
        <size-cm-conversion-table></size-cm-conversion-table>
        <template #modal-footer="{ close }">
          <b-button class="w-100" variant="default" @click="close()">{{ $t('modal.button.close.label') }}</b-button>
        </template>
      </b-modal>
      <b-modal id="download-list" :title="$t('book.efile-list.title')" centered>
        <book-efile-list :efiles="book_efiles"></book-efile-list>
        <template #modal-footer="{ close }">
          <b-button class="w-100" variant="default" @click="close()">{{ $t('modal.button.close.label') }}</b-button>
        </template>
      </b-modal>
      <dharma-grant-susp-msg-modal id="dharma-grant-susp-msg-modal"></dharma-grant-susp-msg-modal>
    </div>
  </div>
</template>
<script>
import Vue from "vue"

import { ButtonGroupPlugin } from 'bootstrap-vue'
import { ButtonPlugin } from 'bootstrap-vue'
import { ButtonToolbarPlugin } from 'bootstrap-vue'
import { CardPlugin } from 'bootstrap-vue'
import { CarouselPlugin } from 'bootstrap-vue'
import { ModalPlugin } from 'bootstrap-vue'

import Tabs from "@/components/Tabs/Tabs.vue"
import TabPane from "@/components/Tabs/TabPane.vue"

import ApplicationList from '@/components/forms/dharma-application-form/ApplicationList'
import DharmaApplicationForm from '@/components/forms/dharma-application-form/DharmaApplicationForm'
import BookInfo from '@/components/info/BookInfo'
import BulletinInfo from '@/components/info/BulletinInfo'
import CourseInfo from '@/components/info/CourseInfo'
import EventInfo from '@/components/info/EventInfo'
import SidelightInfo from '@/components/info/SidelightInfo'
import BookEfileList from '@/components/lists/BookEfileList'
import InfoModal from '@/components/modals/InfoModal.vue'
import SizeCmConversionTable from '@/components/tables/SizeCmConversionTable'
import DharmaGrantSuspMsgModal from '@/components/modals/DharmaGrantSuspMsgModal'

import i18n from '@/plugins/i18n.js'

import BookApiService from '@/services/budaedu-api-services/book-api-service.js'
import BulletinApiService from '@/services/budaedu-api-services/bulletin-api-service.js'
import CarouselApiService from '@/services/budaedu-api-services/carousel-api-service.js'
import CourseApiService from '@/services/budaedu-api-services/course-api-service.js'
import EventApiService from '@/services/budaedu-api-services/event-api-service.js'
import LecturerApiService from '@/services/budaedu-api-services/lecturer-api-service.js'
import SeriesApiService from '@/services/budaedu-api-services/series-api-service.js'
import SidelightApiService from '@/services/budaedu-api-services/sidelight-api-service.js'

Vue.use(ButtonGroupPlugin)
Vue.use(ButtonPlugin)
Vue.use(ButtonToolbarPlugin)
Vue.use(CardPlugin)
Vue.use(CarouselPlugin)
Vue.use(ModalPlugin)

Vue.use(ApplicationList)

Vue.use(BookApiService)
Vue.use(BulletinApiService)
Vue.use(CarouselApiService)
Vue.use(CourseApiService)
Vue.use(EventApiService)
Vue.use(SidelightApiService)
Vue.use(SeriesApiService)
Vue.use(LecturerApiService)

export default {
  i18n,
  name: 'index',
  data() {
    return {
      slides: [
        // // {
        // //   related: { type: 'bulletin', data: { id: 1198 }  },
        // //   background_image: { url: "img/for-index/banner-1200x720-001.png"}
        // // },
        // {
        //   related: { type: 'bulletin', data: { id: 1126 }  },
        //   background_image: { url: "img/for-index/banner-1200x720-00.png"}
        // },
        // // {
        // //   related: { type: 'course', data: { id: 914 }  },
        // //   background_image: { url: "img/for-index/banner-1200x720-01.png"}
        // // },
        // // {
        // //   related: { type: 'course', data: { id: 906 }  },
        // //   background_image: { url: "img/for-index/banner-1200x720-011.png"}
        // // },
        // // {
        // //   related: { type: 'course', data: { id: 906 }  },
        // //   background_image: { url: "img/for-index/banner-1200x720-012.png"}
        // // },
        // // {
        // //   related: { type: 'event', data: { id: 7 }  },
        // //   background_image: { url: "img/for-index/banner-1200x720-021.png" }
        // // },
        // {
        //   related: { type: 'event', data: { id: 8 }  },
        //   background_image: { url: "img/for-index/banner-1200x720-022.png" }
        // },
        // {
        //   related: { type: 'event', data: { id: 24 }  },
        //   background_image: { url: "img/for-index/banner-1200x720-023.png" }
        // },
        // {
        //   related: { type: 'book', data: { id: 5366 }  },
        //   background_image: { url: "img/for-index/banner-1200x720-03.png" }
        // },
        // // {
        // //   related: { type: 'book', data: { id: 2212 }  },
        // //   background_image: { url: "img/for-index/banner-1200x720-032.png" }
        // // }
      ],
      links_tw: [
        {
          image: { url: 'img/index/quick-access-news-zh.png' },
          to: { name: 'bulletins' }
        },
        {
          image: { url: 'img/index/quick-access-books-zh.png' },
          to: {
            name: 'dharmas',
            params: {
              group: 'applicable',
              type: 'book'
            },
            query: { language: 'chinese' }
          }
        },
        {
          image: { url: 'img/index/quick-access-class-zh.png' },
          to: { name: 'today-courses' }
        },
        {
          image: { url: 'img/index/quick-access-video-zh.png' },
          to: { name: 'live-streaming-series' }
        },
        { 
          image: { url: 'img/index/quick-access-holiday-class-zh.png' },
          to: { name: 'latest-session-in-colleges' }
        },
        {
          image: { url: 'img/index/quick-access-hwadzan-garden-zh.png' },
          to: { name: 'latest-events' }
        },
        {
          image: { url: 'img/index/quick-access-search-zh.png' },
          to: { name: 'search' }
        },
        {
          image: { url: 'img/index/quick-access-protection-life-and-env-zh.png' },
          to: { name: 'love-life-articles', params: { type: 'sutra' } }
        }
      ],
      links_en: [
        {
          image: { url: 'img/index/quick-access-apply-en.png' },
          to: {
            name: 'dharmas',
            params: {
              group: 'applicable',
              type: 'book'
            },
            query: { language: 'english' }
          }
        },
        {
          image: { url: 'img/index/quick-access-download-en.png' },
          to: {
            name: 'dharmas',
            params: {
              group: 'downloadable',
              type: 'book'
            },
            query: { language: 'english' }
          }
        },
        {
          image: { url: 'img/index/quick-access-video-en.png' },
          to: { name: 'ongoing-series' }
        },
        {
          image: { url: 'img/index/quick-access-search-en.png' },
          to: { name: 'search' }
        }
      ],
      default_photo: { url: 'img/common.jpg' },
      books: [],
      courses: [],
      series: [],
      book: null,
      course: null,
      event: null,
      sidelight: null,
      bulletin: null,
      book_efiles: []
    };
  },
  watch: {
    '$i18n.locale'(new_locale, old_locale) {
      this.setBooks()
    }
  },
  methods: {
    addBookToApplicationList(book) {
      this.$dharmaApplicationList.addItem({
        code: book.code,
        name: book.chinese_name,
        quantity: book.quantity,
        advanced: book.advanced,
        apply_type: 'book'
      })

      this.$bvModal.show(`application-success-message-${this.$refs[`application_form`].uuid}`)

      // this.showDharmaGrantSuspensionMessage()
    },
    async showSlideRelatedData(related) {
      if (related.type == 'book') {
        this.showBookInfo(related.data)
      } else if (related.type == 'course') {
        this.showCourseInfo(related.data)
      } else if (related.type == 'event') {
        this.showEventInfo(related.data)
      } else if (related.type == 'sidelight') {
        this.showSidelightInfo(related.data)
      } else if (related.type == 'bulletin') {
        this.showBulletinInfo(related.data) // 最新消息
      }
    },
    showBookInfo(book) {
      this.book = book
      this.$bvModal.show('book-info')
    },
    showDharmaGrantSuspensionMessage() {
      this.$bvModal.show('dharma-grant-susp-msg-modal')
    },
    async showDownloadList(book) {
      this.book_efiles = await this.$bookApiService.getEfiles(book);
      this.$bvModal.show('download-list');
    },
    showCourseInfo(course) {
      this.course = course
      this.$bvModal.show('course-info')
    },
    showEventInfo(event) {
      this.event = event
      this.$bvModal.show('event-info')
    },
    showBulletinInfo(bulletin) {
      this.bulletin = bulletin
      this.$bvModal.show('bulletin-info')
    },
    showSidelightInfo(sidelight) {
      this.sidelight = sidelight
      this.$bvModal.show('sidelight-info')
    },
    async setSlides() {
      const slides_order = ['bulletin', 'sidelight', 'course', 'event', 'book']
      const items = await this.$carouselApiService.getActive('include=attachments')
      const carousels = items.data

      const slides = carousels.map(carousel => {
        return {
          publish_date: carousel.publish_date.slice(0, 10),
          related: {
            type: carousel.related_resource_type,
            data: { id: carousel.related_resource_identifier }
          },
          background_image: {
            url: carousel.attachments.length > 0 ? carousel.attachments[0].url : null
          },
          updated_at: carousel.updated_at
        }
      })

      if (slides.length > 0) {
        this.slides = slides.sort((a, b) => {
          let sorting_result = slides_order.indexOf(a.related.type) - slides_order.indexOf(b.related.type)
          if (sorting_result === 0) {
            sorting_result = b.publish_date.localeCompare(a.publish_date)
            if (sorting_result === 0) {
              sorting_result = b.updated_at.localeCompare(a.updated_at)
            }
          }
          return sorting_result
        })
      }
    },
    async setSlideRelatedData() {
      const related_data_promises = this.slides.map(async (slide) => {
        if (slide.related.type == 'book') {
          const book = await this.$bookApiService.getById(slide.related.data.id)
          slide.related.data = book.data
        } else if (slide.related.type == 'course') {
          const course = await this.$courseApiService.getById(slide.related.data.id)
          slide.related.data = course.data
        } else if (slide.related.type == 'event') {
          const event = await this.$eventApiService.getById(
            slide.related.data.id,
            'include=detail.attachments'
          )
          slide.related.data = event.data
        } else if (slide.related.type == 'bulletin') {
          const bulletin = await this.$bulletinApiService.getById(slide.related.data.id, 'include=attachments')
          slide.related.data = bulletin.data
        } else if (slide.related.type == 'sidelight') { // 側邊欄
          const item = await this.$sidelightApiService.getById(
            slide.related.data.id,
            'include=attachments'
          )
          slide.related.data = item.data
          this.$set(slide.related.data, 'photo_compressed_files', await this.getSidelightPhotoCompressedFiles(slide.related.data.id))
          this.$set(slide.related.data, 'photos', await this.getSidelightPhotos(slide.related.data.id))
          this.$set(slide.related.data, 'videos', await this.getSidelightVideos(slide.related.data.id))
        }
      })

      await Promise.all(related_data_promises)
    },
    async setBooks() {
      const lang = this.$i18n.locale === 'tw' ? 'CH' : 'EN'
      const items = await this.$bookApiService.getRecentlyAdded(
        `filter[have_efile]&filter[code][l]=${lang}%&limit=4`
      )
      const previewPromises = items.data.map(async (book) => {
        book.cover = await this.$bookApiService.getCover(book, this.default_photo)
      })
      await Promise.all(previewPromises)
      this.books = items.data
    },
    async setCourses() {
      const items = await this.$courseApiService.getStartedRecently(
        'include=lecturer,places&limit=4'
      )
      const previewPromises = items.data.map(async (course) => {
        const item = await this.$lecturerApiService.getPhoto(course.lecturer)
        course.lecturer.photo = item ? item.data : this.default_photo
      })
      await Promise.all(previewPromises)
      this.courses = items.data
    },
    async setSeries() {
      const items = await this.$seriesApiService.getWithEpisodesUpdated(4)
      const previewPromises = items.map(async (series) => {
        const { data } = await this.$lecturerApiService.query(`filter[lecr_no]=${series.lecr_no}`)
        const item = await this.$lecturerApiService.getPhoto(data[0])
        series.photo = item !== null ? item.data : this.default_photo
      })
      await Promise.all(previewPromises)
      this.series = items
    },
    async getSidelightPhotoCompressedFiles(sidelight_id) {
      const { data } = await this.$sidelightApiService.fetchPhotoCompressedFiles(sidelight_id)
      return data
    },
    async getSidelightPhotos(sidelight_id) { 
      const { data } = await this.$sidelightApiService.fetchPhotos(sidelight_id)
      return data
    },
    async getSidelightVideos(sidelight_id) { 
      const { data } = await this.$sidelightApiService.fetchVideos(sidelight_id);
      return data.map(item => {
        item.name = item.description
        item.thumbnail = [
          {
            src: 'https://www2.budaedu.org/book-img/CHCoverS/CHtemp.jpg',
            style: 'width:15em;height:3em;'
          }
        ]
        return item;
      }).sort((a, b) => a.name.localeCompare(b.name))
    }
  },
  async created() {
    // alert(`Vue version : ${Vue.version}`)
    await this.setSlides() // 輪播圖
    await this.setSlideRelatedData()
    await this.setBooks()
    await this.setCourses()
    await this.setSeries()
  },
  mounted() {
    // 
  },
  components: {
    BookEfileList,
    BookInfo,
    BulletinInfo,
    CourseInfo,
    DharmaApplicationForm,
    DharmaGrantSuspMsgModal,
    EventInfo,
    InfoModal,
    SidelightInfo,
    SizeCmConversionTable,
    Tabs,
    TabPane
  },
  metaInfo() {
    return {
      title: this.$t('index.title'),
      meta: [{
        vmid: 'description',
        name: 'description',
        content: ''
      }]
    }
  }
};
</script>